<div class="overLayDiv active"></div>
<div id="rightSideBar" *ngIf="inputData">
    <div class="rightSidePanel active" [ngClass]="{ 'w-40pc': inputData.isSmallPanel }">
        <header class="panel-header">
            <div class="viewDemo title-and-video">
                <h2>{{inputData.title}}</h2>
            </div>            
            <div class="panel-left-btn">
                <button type="button" class="btn eod-btn-outline-warning" (click)="closePanelData()">
                    {{ "close" | translate }}
                </button>
            </div>
        </header>
        <div class="eod-panel-body">
            <div *ngIf="inputData && inputData.isGridPanel">
                <div class="block mt-2 heightCalc-16" >    
                    <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12 no-padding-right-left heightCalc-17 padding-top-10">                              
                           <app-grid [columns]="gridColumnDefs" [data]="gridData" [gridConfigItems]="gridConfigItems"
                           (onCellClick)="fnOnGridCellClick($event)" >
                           </app-grid>                
                      </div>     
                                  
               </div>
                <div class="block mt-2">
                    <h6 class="info-text">
                        <i class="fas fa-exclamation-circle" aria-hidden="true"></i>
                        <span>{{ "emp_imp_exp_msg11" | translate }}
                            <a class="eod-link-primary px-1" (click)="goToManEmp()">{{ "label_manageemp" | translate }}</a>
                            {{ "emp_imp_exp_msg12" | translate }}
                        </span>
                    </h6>
                </div>
            </div>
            
            <div class="block mt-2 padding-bottom-30 padding-top-10" *ngIf="inputData && !inputData.isGridPanel">
                <div class="row">
                    <ul class="mt-0 w-100pc ml-0" *ngFor="let item of inputData.data">
                        <li class="w-100pc position-relative mt-3">
                            <span class="d-block">
                                <i [ngClass]="item.icon" *ngIf="item.icon"></i>
                                <span [innerHTML]="sanitizerHtml(item.name)"></span>
                            </span>
                            <span class="position-absolute right-0 top-0px" *ngIf="item.isButtonVisible">
                                <button class="btn btn-primary f-11"
                                    (click)="onSubmitPanel(item)">{{item.buttonTitle}}</button>
                            </span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
